export const LocalizationErrorMessages = {
  SomethingWentWrongAgainLater: 'notifications.error.somethingWentWrongAgainLater',
  ProxyNotFoundError: 'proxyPage.notification.error.proxyNotFoundError',
  ProxyDeletedError: 'proxyPage.notification.error.proxyDeletedError',
} as const;

